import { upperFirst } from "lodash-es";

import { FetchError } from "utils/errors";
import { isJson } from "utils/json";

import { GENERIC_ERROR } from "./constants";

// Only token errors carry a meaningful message; auth/account/flag rejections are a uniform 404.
const BACKEND_MESSAGE_STATUSES = new Set([400, 401]);

const getFlowsLinkConfirmErrorMessage = (error: unknown): string => {
  if (error instanceof FetchError && BACKEND_MESSAGE_STATUSES.has(error.status)) {
    const raw = error.message.trim();

    // Skip the empty-body sentinel ("FetchError") and any JSON-envelope body.
    if (raw && raw !== "FetchError" && !isJson(raw)) {
      return upperFirst(raw);
    }
  }

  return GENERIC_ERROR;
};

export default getFlowsLinkConfirmErrorMessage;
